// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1915":"54b8344a","2380":"da886608","3002":"5da24275","3756":"05b1078f","6415":"88e69e2e","7542":"92616bba","9374":"0aedf18c"}[chunkId] + ".css";
};